import { PublishedServiceId } from './ServiceId';
import { PublishedProjectId } from './ProjectId';

const services: Readonly<{[key in PublishedServiceId]: Array<`${PublishedProjectId}`> }> = {
    [PublishedServiceId.Default]                : [],
    [PublishedServiceId.DoorWindowShutterBlind] : [
        PublishedProjectId.WindowAndDoorWindow,
        PublishedProjectId.SlidingBayWindow,
        PublishedProjectId.FrontDoorAndService,
        PublishedProjectId.CustomGarageDoor,
        PublishedProjectId.ShutterAndAwning],
    [PublishedServiceId.FenceAndGate]: [
        PublishedProjectId.PortalAndGate,
        PublishedProjectId.DelimitationAndFence,
        PublishedProjectId.Claustra],
    [PublishedServiceId.PergolaVerandaAndShelters]: [
        PublishedProjectId.GardenPavilionDesignAndBuild,
        PublishedProjectId.LayoutAndBuildOfPoolHouse,
        PublishedProjectId.PorchDesignAndLayout,
        PublishedProjectId.DesignAndBuildOfGardenSheds,
        PublishedProjectId.ArborDesignAndBuild,
        PublishedProjectId.VerandaDesignAndBuild,
        PublishedProjectId.PergolaConstruction,
        PublishedProjectId.Blinds,
        PublishedProjectId.GreenhouseBuild],
    [PublishedServiceId.StaircaseAndGuardrail]: [
        PublishedProjectId.Stairs,
        PublishedProjectId.Guardrail],
    [PublishedServiceId.InteriorDoorGlassRoofAndPartition]: [
        PublishedProjectId.InteriorDoor,
        PublishedProjectId.CustomGlassWall,
        PublishedProjectId.PartitionWall],
    [PublishedServiceId.CustomTerrace]: [
        PublishedProjectId.TerraceDesignAndBuild],
    [PublishedServiceId.StorageUnitAndCupboard]: [
        PublishedProjectId.CustomLibrary,
        PublishedProjectId.CustomWardrobe,
        PublishedProjectId.BuffetAndSideboard,
        PublishedProjectId.OfficePedestals,
        PublishedProjectId.Trunk,
        PublishedProjectId.ChestsOfDrawersAndCabinet,
        PublishedProjectId.CustomShelves,
        PublishedProjectId.CustomBuiltInCabinet,
        PublishedProjectId.Storage,
        PublishedProjectId.CustomKitchenCupboard,
        PublishedProjectId.ClosetDoor,
        PublishedProjectId.CustomPantry,
        PublishedProjectId.WineCellarDesignAndLayout,
        PublishedProjectId.HallwayCabinetAndShoes,
        PublishedProjectId.TvUnit],
    [PublishedServiceId.Table]: [
        PublishedProjectId.DiningTableHighTableBarTable,
        PublishedProjectId.LowTable,
        PublishedProjectId.SideTableAndBedsideTable,
        PublishedProjectId.CustomWorkPlan,
        PublishedProjectId.SofaAndPedestalTable],
    [PublishedServiceId.DeskAndMeetingTable]: [
        PublishedProjectId.Desk,
        PublishedProjectId.MeetingTable],
    [PublishedServiceId.Seated]: [
        PublishedProjectId.BenchAndStool,
        PublishedProjectId.BenchAndBenchSeat,
        PublishedProjectId.Pouf,
        PublishedProjectId.Sofa,
        PublishedProjectId.EndOfBed,
        PublishedProjectId.BarChairAndStool,
        PublishedProjectId.ChairAndArmchair],
    [PublishedServiceId.BedroomAndBedding]: [
        PublishedProjectId.CustomBed,
        PublishedProjectId.Bedhead,
        PublishedProjectId.EndOfBed,
        PublishedProjectId.BedroomDesign,
        PublishedProjectId.ChildrenBedroomDesign,
        PublishedProjectId.BedroomLayout],
    [PublishedServiceId.FrontDoorAndService]: [
        PublishedProjectId.FrontDoorAndService],
    [PublishedServiceId.Kitchen]: [
        PublishedProjectId.KitchenBuild,
        PublishedProjectId.OutdoorKitchenBuild,
        PublishedProjectId.CustomKitchenCabinet,
        PublishedProjectId.CustomKitchenBaseCabinet,
        PublishedProjectId.KitchenIsland,
        PublishedProjectId.KitchenBack,
        PublishedProjectId.WineCellarDesignAndLayout,
        PublishedProjectId.CustomKitchenCupboard,
        PublishedProjectId.CustomWorkPlan],
    [PublishedServiceId.StoneAndWorktop]: [
        PublishedProjectId.CustomWorkPlan,
        PublishedProjectId.InstallationOfCredenza,
        PublishedProjectId.StoneLaying],
    [PublishedServiceId.DecorationAndLighting]: [
        PublishedProjectId.CustomCurtainAndVeil,
        PublishedProjectId.CustomRugs,
        PublishedProjectId.WallHanging,
        PublishedProjectId.CustomLight,
        PublishedProjectId.Mirror,
        PublishedProjectId.WallPaneling,
        PublishedProjectId.GreenWall],
    [PublishedServiceId.MirroringAndGlazing]: [
        PublishedProjectId.Mirror,
        PublishedProjectId.GlassWindowGlazingAndMirrorCutting,
        PublishedProjectId.CustomGlassWall,
        PublishedProjectId.ShowerDoor],
    [PublishedServiceId.ShopLayout]: [
        PublishedProjectId.ShopLayoutAndFurniture],
    [PublishedServiceId.LayoutAndFurnitureCofeeHotelAndRestaurant]: [
        PublishedProjectId.CHRLayoutAndFurniture,
        PublishedProjectId.HouseOutsideLayoutAndFurniture,
        PublishedProjectId.HouseInteriorLayoutAndFurniture],
    [PublishedServiceId.WorkspaceLayoutAndFurniture]: [
        PublishedProjectId.WorkspaceLayoutAndFurniture],
    [PublishedServiceId.InteriorAndOutdoorLayoutAndFurniture]: [
        PublishedProjectId.HouseOutsideLayoutAndFurniture,
        PublishedProjectId.HouseInteriorLayoutAndFurniture],
    [PublishedServiceId.PoolSpaAndSauna]: [
        PublishedProjectId.AboveGroundPool,
        PublishedProjectId.PoolDeckDesignAndLayout,
        PublishedProjectId.SwimingPoolLightingInstallation],
    [PublishedServiceId.ParquetFloor]: [
        PublishedProjectId.WorkspaceLayoutAndFurniture],
    [PublishedServiceId.CounterBar]: [
        PublishedProjectId.CounterBar],
    [PublishedServiceId.ConsoleAndDressingTable]: [
        PublishedProjectId.Console,
        PublishedProjectId.DressingTable],
};

export default services;
